// extracted by mini-css-extract-plugin
export default {"item":"BradCrumbsDesktopItem_item__Rb+TL","item_disabled":"BradCrumbsDesktopItem_item_disabled__vGuUS"};